"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
/** @jsxImportSource @emotion/react */
const react_1 = require("@emotion/react");
const react_2 = require("react");
const fa_1 = require("react-icons/fa");
const ToolTip_1 = __importDefault(require("./ToolTip/ToolTip"));
const styles = (0, react_1.css) `
  background-color: transparent;
  border: none;
  height: 100%;

  svg {
    fill: green;
    font-size: 16px;
  }
`;
function SaveButton(props) {
    const { className = '', disabled = false, popupPlacement = 'left', popupTitle = 'Save', onClick, } = props;
    return ((0, jsx_runtime_1.jsx)("div", { className: className, children: (0, jsx_runtime_1.jsx)(ToolTip_1.default, { title: popupTitle, popupPlacement: popupPlacement, children: (0, jsx_runtime_1.jsx)("button", { css: styles, type: "button", onClick: onClick, disabled: disabled, className: className, children: (0, jsx_runtime_1.jsx)(fa_1.FaCheck, {}) }) }) }));
}
exports.default = (0, react_2.memo)(SaveButton);
